import React from "react";
import "./InputSearch.scss";
import {Input} from "antd";
const InputSearch = props => {
  return (
    <div className="input-search">
      <Input.Search {...props}></Input.Search>
    </div>
  );
};
export default InputSearch;
